export default "__VITE_ASSET__Cp2n1yTO__"